// extracted by css-extract-rspack-plugin
export default {"cls1":"ArticlesFilters-cls1_o5S","cls2":"ArticlesFilters-cls2_RvY ArticlesFilters-cls1_o5S"};